import { Action } from '@ngrx/store';

// @loyaltyDocs: Participation approval flow
export const LOYALTY_APPROVE = '[ParticipationApproving] Approving participation';
export const LOYALTY_APPROVE_SUCCESS = '[ParticipationApproving] Approving participation Success';
export const LOYALTY_APPROVE_ERROR = '[ParticipationApproving] Approving participation Error';
export const LOYALTY_REQUEST = '[ParticipationRequest] Request for participation';
export const LOYALTY_REQUEST_SUCCESS = '[ParticipationRequest] Request for participation Success';
export const LOYALTY_REQUEST_ERROR = '[ParticipationRequest] Request for participation Error';

// Actions for approving participation
export class ApprovingParticipation implements Action {
  readonly type = LOYALTY_APPROVE;
}

export class ApprovingParticipationSuccess implements Action {
  readonly type = LOYALTY_APPROVE_SUCCESS;
  constructor(public payload: boolean) {}
}

export class ApprovingParticipationError implements Action {
  readonly type = LOYALTY_APPROVE_ERROR;
  constructor(public payload: string) {}
}

// Actions for request for participation
export class RequestParticipation implements Action {
  readonly type = LOYALTY_REQUEST;
}

export class RequestParticipationSuccess implements Action {
  readonly type = LOYALTY_REQUEST_SUCCESS;
  constructor(public payload: boolean) {}
}

export class RequestParticipationError implements Action {
  readonly type = LOYALTY_REQUEST_ERROR;
  constructor(public payload: any) {}
}

export type ParticipationActions =
  | ApprovingParticipation
  | ApprovingParticipationSuccess
  | ApprovingParticipationError
  | RequestParticipation
  | RequestParticipationSuccess
  | RequestParticipationError;
